import clg from "functions/log";
import React from "react";
import { Link } from "react-router-dom";

const Button = ( props ) => {

/*  const classes = ( props.classes ? props.classes : null );
    const onClick = ( props.onClick ? props.onClick : null );*/
    
    const to = ( props.to ? props.to : null ); 
    const text = ( props.text ? props.text : null );
    const icon = ( props.icon ? <i className={ props.icon }></i> : null );
    const loader = ( props.loader === 1 ? <div className="btn-loader"><div></div><div></div><div></div></div> : "" )
    const loaderState = ( props.loader === 1 ? true : false )

    return(
        <>
        {
            /* !to ? <button onClick={ onClick ?? onClick } className={"btn" + ( classes ? " " + classes : "" )}>{ text ?? text }</button>
            : <Link to={ to ?? to  } className={"btn" + ( classes ? " " + classes : "" )}>{ text ?? text }</Link> */

            !to ? <button {...props} className={"btn " + props.className + ( loaderState ? " loader-active" : "" )}>{ icon ?? icon }{ text ?? text }{loader}</button>
            : <Link {...props} className={"btn " + props.className} >{ icon ?? icon }{ text ?? text }</Link>
        }
        
        </>
    )
}

export default Button;